export default __webpack_public_path__ + "static/media/shoe.ff6550dd.jpg";